module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAbBAMAAABlxgnoAAAAHlBMVEUAAAAWsToWsToWsToWsToWsToWsToWsToWsToWsTo67toGAAAACXRSTlMA89WldEAZjMranF6TAAAAdElEQVQY02MoNGNAgJkTHZA4MycFIHFmTk6Ac6ZIzhSBcyYkz5ypCucwBM2caQbnMDgCjYRz2CyBRsI4DKyaQCNhHAYWoJFwDgPISDgHZGQBnMPQCWRhyCD0IEzDtAfhAoTbMF0NMQjhU+xhADEIM9xQQhQAOhxBLkzIy8kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_play.png
// module id = 582
// module chunks = 1 7